import React from "react";

const AuthPageAside = ({ children }) => (
  <aside className="right">
    <div className="glow-top"></div>
    <div className="right-body">{children}</div>
  </aside>
);

export default AuthPageAside;
